import { MovieStreamFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformAudio } from '../../movie-player/transformers/transform-audio';
import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

export const getChannelAudio = (stream: MovieStreamFragment | null) => {
    const audio = getNotNullableItems(stream?.streamMeta?.audioMetas);

    return transformAudio(audio);
};
